import React from 'react';
import styled from "styled-components";
import StockList from './components/StocksListing';

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  table.drag-drop tbody tr td:first-child {
    cursor: all-scroll;
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const stockManagement = () => {
  const admin = localStorage.getItem("admin");
  const supplier = localStorage.getItem("supplier");
  if(!admin && !supplier) {
    window.location.href = "/not-found";
    return null;
  } else {
    return (
      <HelpPageWrapper>
        <StockList/>
      </HelpPageWrapper>
    );
  }
};

export default stockManagement;